export const PHOTO_BOOK_ID = 'PHOTO_BOOK_ID';
export const ADD_BOOK_ID = 'ADD_BOOK_ID';
export const ADD_FOLDER_ID = 'ADD_FOLDER_ID';
export const ADD_CONTEXT = 'ADD_CONTEXT';
export const SAVE_BOOK_SIZES = 'SAVE_BOOK_SIZES';
export const LOAD_BOOK_SIZES_BY_BOOK_ID = 'LOAD_BOOK_SIZES_BY_BOOK_ID';
export const LOAD_BOOK_COVER_BY_BOOK_ID = 'LOAD_BOOK_COVER_BY_BOOK_ID';
export const GET_BOOK_COVER = 'GET_BOOK_COVER';
export const GET_BOOK_DIMENSIONS = 'GET_BOOK_DIMENSIONS';
export const GET_COVER_MARGINS = 'GET_COVER_MARGINS';
export const GET_COVER_SIZES = 'GET_COVER_SIZES';
export const ADD_AUTOFILL = 'ADD_AUTOFILL';
export const MAX_SHEETS = 'MAX_SHEETS';
export const UPDATE_COVER_SIZE = 'UPDATE_COVER_SIZE';
export const UPDATE_COVER_MARGIN_SIZE = 'UPDATE_COVER_MARGIN_SIZE';
export const UPDATE_BOOK_RATIO = 'UPDATE_BOOK_RATIO';
export const UPDATE_BOOK_SIZES = 'UPDATE_BOOK_SIZES';
export const LOAD_BOOK_CONTEXT = 'LOAD_BOOK_CONTEXT';
export const ADD_PLACEHOLDER_BORDER_SIZE = 'ADD_PLACEHOLDER_BORDER_SIZE';
export const LOAD_PLACEHOLDER_BORDER_SIZE = 'LOAD_PLACEHOLDER_BORDER_SIZE';
export const SET_IS_BABY_BOOK = 'SET_IS_BABY_BOOK';
export const LOAD_BOOK_DIMENSIONS = 'LOAD_BOOK_DIMENSIONS';
export const LOAD_BABY_BOOK_STATUS = 'LOAD_BABY_BOOK_STATUS';



// WEBPACK FOOTER //
// ./src/redux/action-types/bookproperties/index.js